export const commonTheme = {
  data: {
    menu: {
      help: {
        faqLink: 'https://www.billy.dk/support/',
        email: 'support@shine.co',
        phone: '60 24 60 24',
      },
    },
  },
}
